import {
  basicPointOfServiceFactory,
  paginationFactory,
  pointOfServiceFactory,
  priceFactory,
} from 'factories';
import { convertTimestampToDate } from 'helpers';
import {
  Balance,
  FinancialTransactions,
  FinancialTransactionsResult,
  StoreSaleFinancialReportStatusData,
} from 'types';

function populateConsignments(consignmentsData: any = []) {
  return consignmentsData.map((consignment: any) => {
    const { code, price } = consignment;

    return {
      code: code || '',
      price: priceFactory(price),
    };
  });
}

function populateResults(resultsData: any = []): FinancialTransactionsResult[] {
  return resultsData.map((result: any): FinancialTransactionsResult => {
    const { consignments, createdDate, customer, payment } = result;

    return {
      consignments: populateConsignments(consignments),
      createdDate: convertTimestampToDate(createdDate || 0),
      customer: {
        firstName: customer?.firstName || '',
        lastName: customer?.lastName || '',
        cpf: customer?.cpf || '',
        phone: customer?.phone || '',
        cellphone: customer?.cellphone || '',
        email: customer?.email || '',
      },
      payment: {
        status: payment?.status || '',
        paymentDate: convertTimestampToDate(payment?.paymentDate || 0),
        installments: payment?.installments || 0,
        currentInstallment: payment?.currentInstallment || 0,
        amountPrice: priceFactory(payment?.amountPrice),
        feePrice: priceFactory(payment?.feePrice),
        totalPrice: priceFactory(payment?.totalPrice),
        type: payment?.type || '',
        transactionId: payment?.transactionId || '',
        paymentProvider: payment?.paymentProvider || '',
        paymentType: payment?.paymentType || '',
      },
    };
  });
}

export function financialTransactionFactory(
  params: any = {}
): FinancialTransactions {
  const { pagination, results } = params;

  return {
    pagination: paginationFactory(pagination),
    results: populateResults(results),
  };
}

export function balanceFactory(
  params: any = {},
  fields: 'BASIC' | 'FULL'
): Balance {
  const { available, pointOfService, transferred, waitingFunds } = params;

  const pointOfServiceData =
    fields === 'BASIC'
      ? basicPointOfServiceFactory(pointOfService)
      : pointOfServiceFactory(pointOfService);

  return {
    available: priceFactory(available),
    pointOfService: fields ? pointOfServiceData : undefined,
    transferred: priceFactory(transferred),
    waitingFunds: priceFactory(waitingFunds),
  };
}

export function reportStatusFactory(
  params: any = {}
): StoreSaleFinancialReportStatusData {
  const { startDate, endDate, status } = params;

  return {
    startDate: startDate || 0,
    endDate: endDate || 0,
    status: status || 'NOT_FOUND',
  };
}
